import { EssentialsOutput, ProductType } from "@3gaam/api/types/essentials";
import {
  localStorageGet,
  localStorageRemove,
  localStorageSet,
} from "@3gaam/shared/utils/localStorage";

export type ServiceType = `${ProductType}`;

export const hasServiceTypes = (serviceType: ServiceType) => {
  const essentials = localStorageGet("ESSENTIALS") as EssentialsOutput,
    userServiceTypes = essentials?.Applicant?.ServiceTypes as ServiceType[];
  return userServiceTypes && userServiceTypes.includes(serviceType);
};

export const isConsultant = () => {
  const essentials = localStorageGet("ESSENTIALS");
  return essentials?.Consultant;
};

export const handleGenerateTimeTableBadge = (routes?: any[]) => {
  const pathname = window.location.pathname;
  const remainedGenerateTimeTableRoutes =
    routes || localStorageGet("GENERATED_TIMETABLE_ROUTES");

  if (remainedGenerateTimeTableRoutes) {
    remainedGenerateTimeTableRoutes.includes(pathname) &&
      remainedGenerateTimeTableRoutes.splice(
        remainedGenerateTimeTableRoutes.indexOf(pathname),
        1,
      );
    remainedGenerateTimeTableRoutes.length > 0
      ? localStorageSet(
          "GENERATED_TIMETABLE_ROUTES",
          remainedGenerateTimeTableRoutes,
        )
      : localStorageRemove("GENERATED_TIMETABLE_ROUTES");
  }
};
